import React, { useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ResizeHandleContainer = styled(Box)(({ theme, isDragging }) => ({
  position: 'absolute',
  top: 0,
  right: -5,
  bottom: 0,
  width: '10px',
  cursor: 'col-resize',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  touchAction: 'none',
  '&:hover .resize-line, &:active .resize-line': {
    backgroundColor: theme.palette.primary.main,
    width: '3px',
    opacity: 1,
  }
}));

const ResizeLine = styled(Box)(({ theme }) => ({
  width: '1px',
  height: '60%',
  backgroundColor: theme.palette.divider,
  opacity: 0.5,
  transition: 'all 0.2s ease',
  pointerEvents: 'none',
}));

const ColumnResizeHandle = ({ columnKey, onResizeStart }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onResizeStart(e, columnKey);
  };
  
  return (
    <ResizeHandleContainer
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={(e) => e.stopPropagation()}
    >
      <ResizeLine className="resize-line" />
    </ResizeHandleContainer>
  );
};

export default ColumnResizeHandle;